// @flow

import { cmsAxios } from './axios-config';

const getFAQs = () => {
  return cmsAxios.get('/faq-sections');
};

export default getFAQs;
